import { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { Edit2, CloseSquare } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, DialogActions, IconButton, TextField, MenuItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '../../icons/save-icon.png';

const RenameSectionModal = observer(({ uiStore, section, updateData, category, btnStyle }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState('');

    const save = async () => {
        setLoading(true);
        const data = await uiStore.renameSection(section, category, value);
        updateData(data);
        setLoading(false);
        setShow(false);
    }

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    useEffect(() => {
        setValue(section.name);
        
    }, [show, section]);

    return (
        <Box>

            {btnStyle === 'iconOnly' &&
                <Tooltip title="Rename">
                    <IconButton onClick={() => setShow(true)} sx={{ ml: 1 }}>
                        <Edit2
                            size="24"
                            variant="Bulk"
                        />
                    </IconButton>
                </Tooltip>
            }

            {btnStyle !== 'iconOnly' &&

                <MenuItem onClick={() => setShow(true)}>
                    <ListItemIcon>
                        <Edit2
                            size="24"
                            variant="Bulk"
                        />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{ fontSize: '14px' }}>Rename</ListItemText>
                </MenuItem>
            }

            <Dialog open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px', width: '370px' }, variant: 'round' }}
            >
                <DialogTitle>
                    Rename {section.name} Section
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        sx={{ margin: '20px 0' }}
                        value={value}
                        disabled={loading}
                        onChange={handleChange}
                        label={'New Section Name'}
                    />
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={!!loading} onClick={save} variant="contained" color="secondary"
                        endIcon={
                            <img src={SaveIcon}
                                alt='Save icon'
                                width={24}
                            />
                        }
                    >
                        Save
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </Box >
    );
});

export default RenameSectionModal;
